import { render } from "./GenaricButon.vue?vue&type=template&id=34bd0509&scoped=true"
import script from "./GenaricButon.vue?vue&type=script&lang=js"
export * from "./GenaricButon.vue?vue&type=script&lang=js"

import "./GenaricButon.vue?vue&type=style&index=0&id=34bd0509&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34bd0509"]])

export default __exports__